import { render } from "./HeroiconsOutlineGift.vue?vue&type=template&id=0f4497c0"
const script = {}

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineGift.vue"]])

export default __exports__